import { Card, Clickable } from '@warp-ds/react';

import { formatReadableDateShortNoWeekday, parseISO } from '../util/datetime-fns';
import { thousandSeparated, validSeoPath } from '../util/formatting';
import type { SeoPlace, SeoText } from './interfaces';

type PopularCitiesCardProps = {
    destination: SeoPlace;
    cdnUrl: string;
    verticalUrl: string;
    lang: SeoText;
    id: string;
};

export const PopularCitiesCard = ({ destination, cdnUrl, verticalUrl, lang, id }: PopularCitiesCardProps) => (
    <Card className="m-16" data-testid="popular-destination-card">
        <div aria-owns={`${id}-headingToDestination ${id}-title`} />
        <img
            src={`${cdnUrl}${destination.image}.jpg`}
            loading="lazy"
            alt={`${lang.headingToDestination} ${destination.city}`}
            data-testid="popular-card-image"
        />
        <div className="p-16">
            <p className="flex justify-between text-14">
                <span id={`${id}-headingToDestination`}>{lang.headingToDestination}</span>
                {destination.priceData && (
                    <span>
                        {formatReadableDateShortNoWeekday(parseISO(destination.priceData.departureDate))}
                        {destination.priceData.returnDate &&
                            ` - ${formatReadableDateShortNoWeekday(parseISO(destination.priceData.returnDate))}`}
                    </span>
                )}
            </p>
            <h3 id={`${id}-title`} className="flex justify-between mb-0 text-16">
                <Clickable
                    href={`${verticalUrl}${validSeoPath(destination.country ?? '')}/${
                        destination.city ? `${validSeoPath(destination.city)}/` : ''
                    }`}
                    title={`${destination.city}, ${destination.country}`}
                    className="s-text hover:no-underline"
                    data-testid="popular-card-title">
                    {`${destination.city}, ${destination.country}`}
                </Clickable>
                {((destination.price ?? 0) > 0 || destination.priceData) && (
                    <div>
                        <span className="text-14">Fra </span>
                        <span>{`${thousandSeparated(destination.priceData?.price ?? destination.price)} kr`}</span>
                    </div>
                )}
            </h3>
        </div>
    </Card>
);
